export default {
  SOMETHING_WENT_WRONG: "Something went wrong",
  PAGE_NOT_ALLOWED: "You are not allowed to access this page",
  FILE_UPLOAD_ERROR: "Error while uploading the file",
  SUPPLIER_X_HAS_X_MIN_PURCHASE:
    "Supplier {supplierName} requires a minimum order of {minPurchase} per delivery. The order may be rejected if you do not reach this amount.",
  SUPPLIER_X_HAS_X_MAX_PURCHASE:
    "Supplier {supplierName} has a maximum of {maxPurchase} for your establishment. Please make sure you have your supervisor's approval before confirming this order.",
  INVALID_EXPECTED_DELIVERY_DATE:
    "The expected delivery date does not match the supply rules.",
  ESTABLISHMENT_NOT_ACTIVE:
    "This establishment is deactivated. This operation is not allowed.",
  WEEKLY_REPORT_WAGES_REQUIRED:
    "Wages for this week have not been entered. Enter them in the « Details » tab before validating the report.",
  ESTABLISHMENT_WEEKLY_REPORTS_DISABLED:
    "This establishment does not produce weekly reports. Check « Produces weekly reports » on its record to create one.",
  PRODUCTION_ESTABLISHMENT_REQUIRED: "Choose the production establishment.",
  TRANSFER_HAS_NO_ITEMS: "Add at least one equipment before submitting the transfer.",
  RETURN_DATE_REQUIRED_FOR_TEMPORARY_TRANSFER:
    "A return date is required for a temporary transfer.",
  EQUIPMENT_ALREADY_ON_LOAN: "One of the equipments is already on loan on another transfer.",
  CANNOT_UPDATE_TRANSFER_NOT_DRAFT: "A transfer that is no longer a draft cannot be edited.",
  CANNOT_ACCEPT_NON_SUBMITTED_TRANSFER: "Only a submitted transfer can be accepted.",
  SUBMITTER_CANNOT_ACCEPT_TRANSFER: "You cannot accept a transfer you submitted yourself.",
  USER_NOT_ALLOWED_TO_ACCEPT_TRANSFER: "You are not allowed to accept this transfer.",
  USER_NOT_ALLOWED_TO_CANCEL_ACCEPTED_TRANSFER: "You are not allowed to cancel a transfer that was already accepted.",
  USER_NOT_ALLOWED_TO_SEND_TRANSFER: "You are not allowed to e-mail this transfer.",
  USER_NOT_ALLOWED_TO_RETURN_TRANSFER: "You are not allowed to return this transfer.",
  INTERNAL_ORDER_DELIVERY_DATE_REQUIRED:
    "State the ordered day this invoice settles: that day is what dates the invoice.",
  INTERNAL_ORDER_DELIVERY_DATE_OUT_OF_WEEK:
    "That day does not belong to the week of the internal order.",
  INTERNAL_INVOICE_DATE_MUST_BE_AN_ORDERED_DAY:
    "The internal invoice date must be one of the days of the internal order it settles.",
  INTERNAL_ORDER_WEEK_ALREADY_TAKEN:
    "Another internal order already exists for that week. Cancel or edit it instead of reopening this one.",
  INTERNAL_ORDER_NOT_CONFIRMED:
    "The internal order has to be confirmed before it can be invoiced.",
  DAY_ALREADY_INVOICED:
    "That day already has an internal invoice. Reject or cancel the existing one to redo it.",
  REMAINING_ITEMS_EMPTY_FOR_DAY: "There is nothing left to invoice for that day.",
  INTERNAL_INVOICE_DATE_IS_NOT_EDITABLE:
    "The date of an internal invoice cannot be changed: it is the ordered day it settles.",
  ONLY_TRANSFER_AUTHOR_CAN_REVERT_TO_DRAFT:
    "Only the author of the transfer can revert it to draft.",
  CANNOT_REVERT_TRANSFER_IN_THIS_STATUS:
    "This transfer can no longer be reverted to draft in its current status.",
  CANNOT_RETURN_PERMANENT_TRANSFER: "A permanent transfer cannot be returned.",
  CANNOT_RETURN_TRANSFER_IN_CURRENT_STATUS:
    "This transfer cannot be returned in its current status.",
  CANNOT_RETURN_ITEM_IN_CURRENT_STATUS:
    "This equipment cannot be returned in the current status of the transfer.",
  ITEM_ALREADY_RETURNED: "This equipment has already been returned.",
  TRANSFER_NOT_FOUND: "Transfer not found.",
  UPDATE_FAILED: "Update failed",
  CREATION_FAILED: "Creation failed",
  DOWNLOAD_FAILED: "Download failed",
  ERROR: "Error",
  IS_REQUIRED: "is required",
  CANNOT_CANCEL_INTERNAL_INVOICE_IN_THIS_STATUS:
    "This internal invoice cannot be canceled in its current status.",
  INTERNAL_INVOICE_LOCKED_BY_VALIDATED_WEEKLY_REPORT:
    "Cannot cancel: a weekly report covering that day is already validated.",
  CANCELLATION_REASON_REQUIRED: "A cancellation reason is required.",
  NON_RECEPTION_REASON_REQUIRED:
    "Nothing was received for that day: state the non-reception reason.",
  NON_RECEPTION_REASON_INVALID: "This non-reception reason is not recognized.",
  NON_RECEPTION_REASON_DETAIL_REQUIRED: "Add details when choosing “Other”.",
  CANCELLATION_REASON_INVALID: "This cancellation reason is not recognized.",
  CANCELLATION_REASON_DETAIL_REQUIRED: "Add details when choosing “Other”.",
  USER_NOT_ALLOWED_TO_CANCEL_INTERNAL_INVOICE:
    "You are not allowed to cancel this internal invoice.",
  REJECTION_REASON_REQUIRED: "A rejection reason is required.",
  REJECTION_REASON_INVALID: "This rejection reason is not recognized.",
  REJECTION_REASON_DETAIL_REQUIRED: "Add details when choosing “Other”.",
  USER_NOT_ALLOWED_TO_REJECT_INTERNAL_ORDER:
    "You are not allowed to reject this internal order.",
};
